const state = {
  purchaseOrder: null,
  receipt: null,
  suppliers: {},
  newRowPart: {},
  newReceiptRow: null,
  refreshStatus: null
};
const getters = {
  getCurrentPO: state => state.purchaseOrder,
  getCurrentReceipt: state => state.receipt,
  siteSuppliers: state => state.suppliers,
  getNewPORowParts: state => state.newRowPart,
  getNewReceiptRow: state => state.newReceiptRow,
  getStatusRefresh: state => state.refreshStatus
};
const mutations = {
  setCurrentPO(state, purchaseOrder) {
    state.purchaseOrder = purchaseOrder
  },
  setCurrentReceipt(state, receipt) {
    state.receipt = receipt
  },
  setPORowParts(state, parts) {
    state.newRowPart = parts
  },
  setNewReceiptRow(state, row) {
    state.newReceiptRow = row
  },
  setRefreshStatus(state, val) {
    let id = Object.keys(val)[0]
    let status = Object.values(val)[0]
    state.refreshStatus = { [id]: status }
  }
};
const actions = {
  setSuppliers({commit, state}, suppliers) {
    let supplierObj = {}
    for (let supplier of suppliers) {
      supplierObj[supplier.id] = supplier.name
    }
    state.suppliers = supplierObj
    commit("setValueLoaded", "suppliers")
  },
};
  
export default {
  state,
  getters,
  mutations,
  actions
};